(function() {
	'use strict';
	var lang = document.documentElement.getAttribute('lang');

	if (lang == 'ja-jp') {
		var testimonialsJP = tns({
			"container": ".slider-fad-testimonials-jp",
			"controlsContainer": ".slider-fad-testimonials-jp-controls",
			"preventScrollOnTouch": "force",
			"controlsPosition": "bottom",
			"navPosition": "bottom",
			"gutter": 24,
			"slideBy": "page",
			"responsive": {
				"768": {
					"items": 2
				},
				"992": {
					"gutter": 32
				},
				"1280": {
					"items": 2
				}
			}
		});

		// Create a slide counter bellow the Carousel
		avm.require('avast.web.slideCounter')(testimonialsJP);

	} else {
		var testimonials = tns({
			"container": ".slider-fad-testimonials",
			"controlsContainer": ".slider-fad-testimonials-controls",
			"preventScrollOnTouch": "force",
			"controlsPosition": "bottom",
			"navPosition": "bottom",
			"gutter": 24,
			"slideBy": "page",
			"responsive": {
				"992": {
					"gutter": 32
				}
			}
		});

		// Create a slide counter bellow the Carousel
		avm.require('avast.web.slideCounter')(testimonials);
	}

})();
